
       <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">
          Purchase Order List
        </div>
         <div class="row mt-2 pl-1">
           <div class="input-group col-md-8 ">   
            <div class="col">
              <div class="input-group">
                  <span class="input-group-prepend">
                      <div class="input-group-text bg-transparent border-right-0"><i class="fa fa-search" [ngClass]="{'dark-bg' : isDark }"></i></div>
                  </span>
                  <input [(ngModel)]="searchKey" (keyup)="applyFilter()" autocomplete="off" [ngClass]="{'dark-bg' : isDark }" class="form-control py-2 border-left-0  border-right-0 border" type="text" placeholder="Search">
                  <span class="input-group-append">
                    <button class="btn  border-left-0 border" type="button">
                        <i *ngIf="searchKey" (click)="onSearchClear()" class="fa fa-close" [ngClass]="{'dark-bg' : isDark }"></i>
                    </button>
                  </span>            
              </div>     
            </div>
                  
          </div>
           <div class="col-md-4">
             <button *ngIf="crud_access.create"  class="btn btn-success float-right mr-4 " (click)="newButtonClick()"><i class="fa fa-plus p-1"></i>New Purchase Order</button>
           </div>      
         </div>
      
         <fieldset>
         <div class="card-body">

          <div>
          <mat-table [dataSource]="dataSource" matSort>
           
            <ng-container matColumnDef="poNo">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> PO No. </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.PONo}} </mat-cell>
            </ng-container>
                     
            <ng-container matColumnDef="date">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Date </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.Date | date :'y-MM-dd'}} </mat-cell>
            </ng-container>
                    
            <ng-container matColumnDef="supplier">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Supplier </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.SupName}} </mat-cell>
            </ng-container>
                   
            <ng-container matColumnDef="amount">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Amount </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }"> {{element.GrandTotal |  number:'1.2-2'}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'dark-bg' : isDark }"> Status </mat-header-cell>
              <mat-cell *matCellDef="let element" [ngClass]="{'dark-bg' : isDark }">{{element.Status }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdBy">
              <mat-header-cell *matHeaderCellDef mat-sort-header  [ngClass]="{'dark-bg' : isDark }"> CreatedBy </mat-header-cell>
              <mat-cell *matCellDef="let element"  [ngClass]="{'dark-bg' : isDark }"> {{element.CreatedBy}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef [ngClass]="{'dark-bg' : isDark }"> Action </mat-header-cell>
              <mat-cell *matCellDef="let row" [ngClass]="{'dark-bg' : isDark }">
                <button *ngIf="crud_access.read"  class="btn btn-primary btn-sm  text-white" (click)="viewDetailsButtonClick(row.PONo)" data-toggle="viewTooltip" data-placement="bottom" title="View"><i class="far fa-folder-open"></i></button>
                <button *ngIf="crud_access.delete"  class="btn btn-danger btn-sm ml-1 text-white " (click)="deleteButtonClick(row.PONo)"  data-toggle="deleteTooltip" data-placement="bottom" title="Delete"><i class="far fa-trash-alt"></i></button>       
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="loading">
              <mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> Loading data... </mat-footer-cell> 
            </ng-container>

            <ng-container matColumnDef="noData">
              <mat-footer-cell *matFooterCellDef colspan="6" [ngClass]="{'dark-bg' : isDark }"> No data available in table </mat-footer-cell> 
            </ng-container>
          
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' : dataSource!=null }"></mat-footer-row>
            <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide' : !(dataSource!=null && dataSource.data.length==0)}"></mat-footer-row>
          </mat-table>

          <mat-paginator [ngClass]="{'dark-bg' : isDark }" [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

          </div>
          
         </div>                                
         <!-- /.card-body -->

       </fieldset>

       </div>
     
   <script>
   
     $(function () {
     $('[data-toggle="viewTooltip"]').tooltip()
   })
   $(function () {
     $('[data-toggle="deleteTooltip"]').tooltip()
   })
   </script>



